/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminEbayAccount,
    AdminEbayAccountFromJSON,
    AdminEbayAccountFromJSONTyped,
    AdminEbayAccountToJSON,
} from './AdminEbayAccount';
import {
    AdminEbayEnvironment,
    AdminEbayEnvironmentFromJSON,
    AdminEbayEnvironmentFromJSONTyped,
    AdminEbayEnvironmentToJSON,
} from './AdminEbayEnvironment';

/**
 * 
 * @export
 * @interface AdminEbayAccountResp
 */
export interface AdminEbayAccountResp {
    /**
     * Account is null when no account is connected.
     * @type {AdminEbayAccount}
     * @memberof AdminEbayAccountResp
     */
    account?: AdminEbayAccount;
    /**
     * ConfigError tells what to fix in the config.
     * @type {string}
     * @memberof AdminEbayAccountResp
     */
    configError?: string;
    /**
     * Configured is false when the EbaySelling config section is empty or incomplete.
     * @type {boolean}
     * @memberof AdminEbayAccountResp
     */
    configured: boolean;
    /**
     * 
     * @type {AdminEbayEnvironment}
     * @memberof AdminEbayAccountResp
     */
    environment?: AdminEbayEnvironment;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayAccountResp
     */
    marketplaceId?: string;
}



export function AdminEbayAccountRespFromJSON(json: any): AdminEbayAccountResp {
    return AdminEbayAccountRespFromJSONTyped(json, false);
}

export function AdminEbayAccountRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayAccountResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : AdminEbayAccountFromJSON(json['account']),
        'configError': !exists(json, 'configError') ? undefined : json['configError'],
        'configured': json['configured'],
        'environment': !exists(json, 'environment') ? undefined : AdminEbayEnvironmentFromJSON(json['environment']),
        'marketplaceId': !exists(json, 'marketplaceId') ? undefined : json['marketplaceId'],
    };
}

export function AdminEbayAccountRespToJSON(value?: AdminEbayAccountResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': AdminEbayAccountToJSON(value.account),
        'configError': value.configError,
        'configured': value.configured,
        'environment': AdminEbayEnvironmentToJSON(value.environment),
        'marketplaceId': value.marketplaceId,
    };
}

